var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","margin":"3px"}},[(_vm.label)?_c('div',[_c('h4',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_c('el-input',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"label":_vm.label},on:{"input":_vm.onchange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }